/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_ShareInputs */

const en_directory_tool_share = /** @type {(inputs: Directory_Tool_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const zh_directory_tool_share = /** @type {(inputs: Directory_Tool_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Directory_Tool_ShareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_share = /** @type {((inputs?: Directory_Tool_ShareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_ShareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_share(inputs)
	return zh_directory_tool_share(inputs)
});
export { directory_tool_share as "directory.tool.share" }